import { render, staticRenderFns } from "./wrist-repord.vue?vue&type=template&id=6c5327ea"
import script from "./wrist-repord.vue?vue&type=script&lang=js"
export * from "./wrist-repord.vue?vue&type=script&lang=js"
import style0 from "./wrist-repord.vue?vue&type=style&index=0&id=6c5327ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports